import VCalendar from 'v-calendar/lib/components/calendar.umd'

export default {
  name: 'Calendar',
  props: ['reqPath'],
  data () {
    return {
      loading: false,
      masks: {
        weekdays: 'WWWW'
      },
      attributes: [],
      fromYear: (new Date()).getFullYear(),
      toYear: (new Date()).getFullYear() + 1,
      modalDate: null,
      modalWindowTitle: 'calendar.event-title.CONTRACT_END',
      modalClients: []
    };
  },
  components: {
    VCalendar
  },
  computed: {
  },
  methods: {
    getCalendarEvents () {
      const self = this;
      self.loading = true;
      this.ApiRequest.request(this.reqPath + '?from=' + this.fromYear + '&to=' + this.toYear, this.ApiRequest.REQUEST_GET, {}, function (response) {
        if (response.data) {
          const events = [];
          response.data.forEach(el => {
            Object.values(el).forEach(dateEl => {
              events.push({
                customData: {
                  api_id: dateEl.api_id,
                  title: dateEl.title,
                  class: 'event-' + dateEl.type,
                  clients: dateEl.clients,
                  type: dateEl.type,
                  date: dateEl.date
                },
                dates: new Date(dateEl.date)
              });
            });
          });
          self.attributes = events;
        }
        self.loading = false;
      });
    },
    calendarChange () {
      let reload = false;
      if (this.fromYear > this.$refs.calendar.lastPage.year) {
        this.fromYear = this.$refs.calendar.lastPage.year;
        this.toYear = this.fromYear + 1;
        reload = true;
      } else if (this.toYear < this.$refs.calendar.lastPage.year) {
        this.toYear = this.$refs.calendar.lastPage.year;
        this.fromYear = this.toYear - 1;
        reload = true;
      }
      if (reload) {
        this.getCalendarEvents();
      }
    },
    viewEvent (eventData, newtab = 0) {
      if (eventData.customData.type === 'SEMINAR') {
        const routeData = this.$router.resolve({ name: 'menu.info.seminars.view', params: { seminarApiId: eventData.customData.api_id } });
        const path = '/info/seminars/' + eventData.customData.api_id + '/view';
        if (newtab) {
          window.open(routeData.href, '_blank');
        } else {
          this.$router.push(path);
          this.$refs['modal-window'].hide();
          this.$emit('linkopen');
        }
      } else {
        this.modalDate = eventData.customData.date;
        this.modelWindowTitle = 'calendar.event-title.' + eventData.customData.title;
        this.modalClients = this.BasicHelper.sortArrayByKeyValue(Object.values(eventData.customData.clients), 'name');
        this.$refs['modal-window'].show();
      }
    },
    onOpenLink (client, newtab = false) {
      if (newtab) {
        const routeData = this.$router.resolve({ name: 'menu.client.edit', params: { clientApiId: client.api_id } });
        window.open(routeData.href, '_blank');
      } else {
        this.$router.push('/client/' + client.api_id + '/edit');
        this.$refs['modal-window'].hide();
        this.$emit('linkopen');
      }
    }
  },
  mounted () {
    this.getCalendarEvents();
  }
}
